// Updated ConnectionCardsSection.tsx
import React, { useRef, useEffect, useState } from "react";
import { motion } from "framer-motion";
import ConnectCard from "../cards/ConnectCard";
import { ConnectionCardData } from "../../types/homeTypes";

interface ConnectionCardsSectionProps {
  connectionCards: ConnectionCardData[];
  handleConnectDevice: (deviceId: string) => void;
  currentuser?: boolean;
}

/**
 * Component for displaying floating connection cards with horizontal parallax scroll
 */
const ConnectionCardsSection: React.FC<ConnectionCardsSectionProps> = ({
  connectionCards,
  handleConnectDevice,
  currentuser = true,
}) => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [scrollProgress, setScrollProgress] = useState(0);

  // Handle scroll for parallax effect
  const handleScroll = () => {
    if (scrollRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
      const maxScroll = scrollWidth - clientWidth;
      const progress = maxScroll > 0 ? scrollLeft / maxScroll : 0;
      setScrollProgress(progress);
    }
  };

  useEffect(() => {
    const scrollContainer = scrollRef.current;
    if (scrollContainer) {
      scrollContainer.addEventListener("scroll", handleScroll);
      return () => scrollContainer.removeEventListener("scroll", handleScroll);
    }
  }, []);

  if (!connectionCards || connectionCards.length === 0) {
    return null;
  }

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        paddingBottom: currentuser ? "160px" : "120px",
      }}
    >
      <motion.div
        className="connection-cards-section"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3 }}
        style={{
          width: "100%",
          overflow: "hidden",
          padding: "0",
          margin: "25px 0",
        }}
      >
        <div
          ref={scrollRef}
          className="connection-cards-container"
          style={{
            display: "flex",
            gap: "16px",
            overflowX: "auto",
            overflowY: "hidden",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            marginTop: "-25px",
            // zIndex: 10,
            position: "absolute",
            paddingTop: "18px",
            width: "100%",
            scrollBehavior: "smooth",
            padding: "8px 16px",
            background: "transparent",
            WebkitOverflowScrolling: "touch",
            justifyContent:
              connectionCards.length === 1 ? "center" : "flex-start",
          }}
        >
          {connectionCards.map((card, index) => (
            <ConnectCard
              key={`connect-card-${card.id || index}`}
              id={card.id}
              title={card.title}
              description={card.description}
              buttonText={card.buttonText}
              onButtonClick={handleConnectDevice}
              scrollProgress={scrollProgress}
              index={index}
            />
          ))}
        </div>
      </motion.div>
    </div>
  );
};

export default ConnectionCardsSection;
